import { env as envPublic } from '$env/dynamic/public';

export enum Feature {
  ESHOP = 'ESHOP',
  OTP = 'OTP',
  NOTIFICATIONS = 'NOTIFICATIONS',
  REDIRECT = 'REDIRECT',
  DONATION = 'DONATION',
}

// Feature flag configuration per publisher
const featureFlagsByPublisher: Record<string, Record<Feature, boolean>> = {
  cashback_visa: {
    [Feature.ESHOP]: false,
    [Feature.NOTIFICATIONS]: false,
    [Feature.REDIRECT]: false,
    [Feature.OTP]: true,
    [Feature.DONATION]: false,
  },
  cba_dk: {
    [Feature.ESHOP]: false,
    [Feature.NOTIFICATIONS]: false,
    [Feature.REDIRECT]: false,
    [Feature.OTP]: false,
    [Feature.DONATION]: false,
  },
  danske_bank: {
    [Feature.ESHOP]: false,
    [Feature.NOTIFICATIONS]: false,
    [Feature.REDIRECT]: false,
    [Feature.OTP]: true,
    [Feature.DONATION]: false,
  },
};

// Check if we're in production
const isProd = envPublic.PUBLIC_ENV === 'production';

// Safely determine publisher (default to 'default' if missing)
const currentPublisher = envPublic.PUBLIC_PUBLISHER ?? 'default';

/**
 * Utility function to check if a feature is enabled
 */
export const isFeatureEnabled = (feature: Feature): boolean => {
  if (!isProd) return true; // Enable all features in non-prod environments (dev, staging, local, etc.)

  // Get feature flags for the current publisher, fallback to empty object (so all features default to false)
  const publisherFlags = featureFlagsByPublisher[currentPublisher] ?? {};

  // Return the feature flag value (default to false if not found)
  return publisherFlags[feature] ?? false;
};
